import React from "react";
import ad1Image from "../media/ad1.png";
import ad2Image from "../media/ad2.png";
import ad3Image from "../media/ad3.png";
import ad4Image from "../media/ad4.png";

import "./style.css";

const fallbackAdUrl =
  process.env.REACT_APP_AD_FALLBACK_URL ||
  "https://adstradex.com/blog/a-tutorial-on-how-to-make-money-online-as-a-publisher-from-your-website-or-a-social-media-pagechannelgroup";

const ads = [
  {
    image: ad1Image,
    title: "Be a Casino Legend - Play and Win!",
    url: process.env.REACT_APP_AD_1_URL || fallbackAdUrl,
  },
  {
    image: ad2Image,
    title: "Unlock the Impossible",
    url: process.env.REACT_APP_AD_2_URL || fallbackAdUrl,
  },
  {
    image: ad3Image,
    title: "Secrets Await",
    url: process.env.REACT_APP_AD_3_URL || fallbackAdUrl,
  },
  {
    image: ad4Image,
    title: "Dream Beyond Reality",
    url: process.env.REACT_APP_AD_4_URL || fallbackAdUrl,
  },
];

const AdPlaceHolder = () => {
  return (
    <section className="ad-strip" aria-label="Sponsored ads">
      {ads.map((ad) => (
        <a
          className="ad-tile"
          href={ad.url}
          key={ad.title}
          rel="nofollow sponsored noopener noreferrer"
          target="_blank"
        >
          <img src={ad.image} alt="" loading="lazy" />
          <strong>{ad.title}</strong>
        </a>
      ))}
    </section>
  );
};

export default AdPlaceHolder;
